export default __webpack_public_path__ + "static/media/mint_live_down_arrow.d249dd54.svg";